const toEnglishDigits = (value) => String(value || '').replace(/[\u09E6-\u09EF]/g, (digit) => String(digit.charCodeAt(0) - 0x09E6));

export const normalizeBangladeshPhone = (value) => {
  const digits = toEnglishDigits(value).replace(/\D/g, '');
  if (/^01[3-9]\d{8}$/.test(digits)) return `+88${digits}`;
  if (/^8801[3-9]\d{8}$/.test(digits)) return `+${digits}`;
  return '';
};

export const isBangladeshMobile = (value) => Boolean(normalizeBangladeshPhone(value));

export const isFakeWhatsAppNumber = (normalizedPhone) => {
  if (!normalizedPhone) return true;
  const digits = normalizedPhone.replace(/\D/g, '');
  if (!/^8801[3-9]\d{8}$/.test(digits)) return true;

  const local = `0${digits.substring(3)}`;
  const suffix = local.substring(3);

  if (/^(\d)\1{7}$/.test(suffix)) return true;
  if (['12345678', '87654321', '01234567', '00000000', '11111111', '99999999'].includes(suffix)) return true;
  if (/^(\d)\1(\d)\2(\d)\3(\d)\4$/.test(suffix)) return true;
  if (/^(\d\d)\1{3}$/.test(suffix)) return true;

  return false;
};

export const checkWhatsAppNumber = async (value) => {
  const normalized = normalizeBangladeshPhone(value);
  if (!normalized || isFakeWhatsAppNumber(normalized)) {
    return { isValid: false, hasWhatsApp: false };
  }
  return { isValid: true, hasWhatsApp: true, normalized };
};